/**
 * Gets the internationalization locale from the document's data attributes.
 * It constructs the locale string in the format "language-LOCALE" (e.g., "en-US").
 * If both language and locale are available, it combines them; otherwise, it falls back to just the language or defaults to "en-US".
 * @returns {string|string|string}
 */
export function getIntlLocale() {
  const documentElement = document.documentElement;
  const language = documentElement.getAttribute("data-hy-language");
  const locale = documentElement.getAttribute("data-hy-locale");

  if (language && locale) {
    return `${language}-${locale.toUpperCase()}`;
  }

  return language || "en-US";
}